import { resolveEndpoint } from '../endpointUtils';

export default {
	getExchangeRate: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/fx',
		x_bpi_version: '1.0.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId });
		},
	},
};
